import { useTranslation } from "react-i18next";

import { shareLink } from "@/shared/telegram";
import { useToast } from "@/shared/ui";

/**
 * Поделиться реферальной ссылкой.
 *
 * Ссылка приходит с бэкенда готовой (`ReferralResponse.link`) — клиент её не
 * собирает. Вне Telegram и на клиентах без `shareURL` метод недоступен;
 * тогда показывается подсказка про копирование, а не тишина по нажатию.
 */
export function useShareReferral() {
  const { t } = useTranslation();
  const toast = useToast();

  return (link: string) => {
    if (!shareLink(link, t("profile.referral.shareText"))) {
      toast.show({ tone: "loss", title: t("profile.referral.shareUnavailable") });
    }
  };
}
